'use strict';

exports.__esModule = true;
exports.TaskConnector = exports.TaskView = exports.styles = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp, _class2, _temp2; // import ArrowForward from "material-ui-icons/ArrowForward";
// import {
//   createTaskProcessor,
//   updateTaskProcessor,
// } from "../../query";
// import {
//   createTimerProcessor,
//   updateTimerProcessor,
// } from "../../../Timers/query";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Editable = require('apollo-cms/lib/DataView/Object/Editable');

var _Editable2 = _interopRequireDefault(_Editable);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _materialUi = require('material-ui');

var _PlayArrow = require('material-ui-icons/PlayArrow');

var _PlayArrow2 = _interopRequireDefault(_PlayArrow);

var _Stop = require('material-ui-icons/Stop');

var _Stop2 = _interopRequireDefault(_Stop);

var _SubdirectoryArrowRight = require('material-ui-icons/SubdirectoryArrowRight');

var _SubdirectoryArrowRight2 = _interopRequireDefault(_SubdirectoryArrowRight);

var _SubdirectoryArrowLeft = require('material-ui-icons/SubdirectoryArrowLeft');

var _SubdirectoryArrowLeft2 = _interopRequireDefault(_SubdirectoryArrowLeft);

var _Close = require('material-ui-icons/Close');

var _Close2 = _interopRequireDefault(_Close);

var _Grid = require('@prisma-cms/front/lib/modules/ui/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _context5 = require('@prisma-cms/context');

var _context6 = _interopRequireDefault(_context5);

var _List = require('../../../Timers/View/List');

var _List2 = _interopRequireDefault(_List);

var _reactApollo = require('react-apollo');

var _Select = require('./Status/Select');

var _Select2 = _interopRequireDefault(_Select);

var _ChatRooms = require('./ChatRooms');

var _ChatRooms2 = _interopRequireDefault(_ChatRooms);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = exports.styles = function styles(theme) {
  return {
    root: {},
    item: {// flexWrap: "nowrap",
    },
    flexNoWrap: {
      flexWrap: "nowrap"
    },
    buttons: {
      display: "flex",
      alignItems: "center",
      "& button": {
        height: 24,
        width: 24,
        "& svg": {
          fontSize: 20
        }
      }
    },
    button: {},
    status: {
      "&.New": {
        backgroundColor: "#aa8cb9"
      },
      "&.Accepted": {
        backgroundColor: "#c7ecc5"
      },
      "&.Rejected": {
        backgroundColor: "lightgray"
      },
      "&.Progress": {
        backgroundColor: "#92f78c"
      },
      "&.Paused": {
        backgroundColor: "#afecec"
      },
      "&.Done": {
        backgroundColor: "#4dfb43"
      },
      "&.Discuss": {
        backgroundColor: "#f7c78c"
      },
      "&.Approved": {
        backgroundColor: "#0bdc0b"
      },
      "&.RevisionsRequired": {
        backgroundColor: "#8ccbf5"
      },
      "&.Completed": {
        backgroundColor: "#05c305"
      }
    }
  };
};

var TaskView = exports.TaskView = (_temp = _class = function (_EditableView) {
  _inherits(TaskView, _EditableView); // static contextTypes = {
  //   ...EditableView.contextTypes,
  //   UserLink: PropTypes.func.isRequired,
  //   TaskLink: PropTypes.func.isRequired,
  //   Editor: PropTypes.func.isRequired,
  //   ProjectLink: PropTypes.func.isRequired,
  //   openLoginForm: PropTypes.func.isRequired,
  // };


  function TaskView(props) {
    _classCallCheck(this, TaskView);

    return _possibleConstructorReturn(this, _EditableView.call(this, props));
  }

  TaskView.prototype.canEdit = function canEdit() {
    var currentUser = this.context.user;

    var _ref = currentUser || {},
        currentUserId = _ref.id,
        sudo = _ref.sudo;

    var _ref2 = this.getObjectWithMutations() || {},
        id = _ref2.id,
        CreatedBy = _ref2.CreatedBy;

    var _ref3 = CreatedBy || {},
        createdById = _ref3.id;

    return !id || createdById && createdById === currentUserId || sudo === true;
  };

  TaskView.prototype.save = function save() {
    var _context = this.context,
        currentUser = _context.user,
        openLoginForm = _context.openLoginForm;

    if (!currentUser) {
      return openLoginForm();
    }

    return _EditableView.prototype.save.call(this);
  };

  TaskView.prototype.saveObject = function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee(data) {
      var _props, mutate, createTask, updateTask, _ref5, id, mutation;

      return _regenerator2.default.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _props = this.props, mutate = _props.mutate, createTask = _props.createTask, updateTask = _props.updateTask;

              if (mutate) {
                _context2.next = 14;
                break;
              }

              _ref5 = this.getObjectWithMutations() || {}, id = _ref5.id;

              if (!(id && updateTask)) {
                _context2.next = 7;
                break;
              }

              mutate = updateTask;
              _context2.next = 14;
              break;

            case 7:
              if (!(!id && createTask)) {
                _context2.next = 11;
                break;
              }

              mutate = createTask;
              _context2.next = 14;
              break;

            case 11:
              _context2.next = 13;
              return _EditableView.prototype.saveObject.call(this, data);

            case 13:
              return _context2.abrupt('return', _context2.sent);

            case 14:
              mutation = this.getMutation(data);
              return _context2.abrupt('return', mutate(mutation));

            case 16:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee, this);
    }));

    function saveObject(_x) {
      return _ref4.apply(this, arguments);
    }

    return saveObject;
  }();

  TaskView.prototype.getCacheKey = function getCacheKey() {
    var _ref6 = this.getObject() || {},
        id = _ref6.id;

    return 'task_' + (id || "new");
  };

  TaskView.prototype.getButtons = function getButtons() {
    var buttons = _EditableView.prototype.getButtons.call(this) || [];
    var _props2 = this.props,
        createTimer = _props2.createTimer,
        updateTimer = _props2.updateTimer,
        classes = _props2.classes;
    var UserLink = this.context.UserLink;
    var object = this.getObjectWithMutations();

    if (object) {
      var taskId = object.id,
          name = object.name,
          Timers = object.Timers,
          CreatedBy = object.CreatedBy,
          onStartRelationTo = object.onStartRelationTo,
          onSetRelationTo = object.onSetRelationTo,
          relationItemTo = object.relationItemTo,
          onStartRelationFrom = object.onStartRelationFrom,
          onSetRelationFrom = object.onSetRelationFrom,
          relationItemFrom = object.relationItemFrom;

      var _ref7 = CreatedBy || {},
          createdById = _ref7.id;

      var currentUser = this.context.user;
      var activeTimers = Timers && Timers.filter(function (n) {
        return n.stopedAt === null;
      }) || [];

      if (activeTimers.length) {
        activeTimers.map(function (n) {
          var id = n.id,
              CreatedBy = n.CreatedBy;
          buttons.push(_react2.default.createElement(UserLink, {
            key: id,
            user: CreatedBy,
            size: 'small',
            showName: false
          }));
        });
      }

      if (currentUser) {
        var currentUserId = currentUser.id;
        var activeTimer = activeTimers.find(function (n) {
          return n.CreatedBy.id === currentUserId;
        });

        if (activeTimer) {
          var timerId = activeTimer.id;
          buttons.push(_react2.default.createElement(_materialUi.IconButton, {
            key: 'stop',
            onClick: function onClick() {
              return updateTimer({
                variables: {
                  data: {
                    stopedAt: new Date()
                  },
                  where: {
                    id: timerId
                  }
                }
              });
            },
            className: classes.button
          }, _react2.default.createElement(_Stop2.default, null)));
        } else {
          buttons.push(_react2.default.createElement(_materialUi.IconButton, {
            key: 'start',
            onClick: function onClick() {
              return createTimer({
                variables: {
                  data: {
                    Task: {
                      connect: {
                        id: taskId
                      }
                    }
                  }
                }
              });
            },
            className: classes.button
          }, _react2.default.createElement(_PlayArrow2.default, null)));
        }

        if (onStartRelationTo && onSetRelationTo) {
          if (relationItemTo) {
            if (relationItemTo.id === taskId) {
              buttons.push(_react2.default.createElement(_materialUi.IconButton, {
                key: 'cancelRelation',
                className: classes.button,
                onClick: function onClick() {
                  return onStartRelationTo(object);
                }
              }, _react2.default.createElement(_Close2.default, null)));
            } else {
              buttons.push(_react2.default.createElement(_materialUi.IconButton, {
                key: 'startRelation',
                className: classes.button,
                onClick: function onClick() {
                  return onSetRelationTo(object);
                }
              }, _react2.default.createElement(_SubdirectoryArrowRight2.default, {
                style: {
                  color: "green"
                }
              })));
            }
          } else if (createdById && createdById === currentUserId) {
            buttons.push(_react2.default.createElement(_materialUi.IconButton, {
              key: 'startRelation',
              className: classes.button,
              onClick: function onClick() {
                return onStartRelationTo(object);
              }
            }, _react2.default.createElement(_SubdirectoryArrowLeft2.default, null)));
          }
        }

        if (onStartRelationFrom && onSetRelationFrom) {
          if (relationItemFrom) {
            if (relationItemFrom.id === taskId) {
              buttons.push(_react2.default.createElement(_materialUi.IconButton, {
                key: 'cancelRelationFrom',
                className: classes.button,
                onClick: function onClick() {
                  return onStartRelationFrom(object);
                }
              }, _react2.default.createElement(_Close2.default, null)));
            } else {
              buttons.push(_react2.default.createElement(_materialUi.IconButton, {
                key: 'startRelationFrom',
                className: classes.button,
                onClick: function onClick() {
                  return onSetRelationFrom(object);
                }
              }, _react2.default.createElement(_SubdirectoryArrowLeft2.default, {
                style: {
                  color: "green"
                }
              })));
            }
          } else if (createdById && createdById === currentUserId) {
            buttons.push(_react2.default.createElement(_materialUi.IconButton, {
              key: 'startRelationFrom',
              className: classes.button,
              onClick: function onClick() {
                return onStartRelationFrom(object);
              }
            }, _react2.default.createElement(_SubdirectoryArrowRight2.default, null)));
          }
        }
      }
    }

    return buttons;
  };

  TaskView.prototype.renderHeader = function renderHeader() {
    var _props3 = this.props,
        classes = _props3.classes,
        showCreatedBy = _props3.showCreatedBy;
    var _context3 = this.context,
        UserLink = _context3.UserLink,
        TaskLink = _context3.TaskLink,
        ProjectLink = _context3.ProjectLink;
    var object = this.getObjectWithMutations();

    var _ref8 = object || {},
        taskId = _ref8.id,
        CreatedBy = _ref8.CreatedBy,
        createdAt = _ref8.createdAt,
        Project = _ref8.Project;

    var inEditMode = this.isInEditMode();
    return _react2.default.createElement('div', {
      className: classes.header
    }, _react2.default.createElement(_Grid2.default, {
      container: true,
      spacing: 8,
      className: classes.headerContainer
    }, _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: true
    }, _react2.default.createElement(_Grid2.default, {
      container: true,
      spacing: 8,
      alignItems: 'center' // className={classes.flexNoWrap}

    }, _react2.default.createElement(_Grid2.default, {
      item: true // xs={inEditMode}
      ,
      style: {
        overflow: "hidden"
      },
      xs: true
    }, inEditMode ? this.getTextField({
      name: "name",
      fullWidth: true,
      label: "Название задачи"
    }) : taskId ? _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(TaskLink, {
      object: object
    }), ' ', Project ? _react2.default.createElement('span', null, ' (', _react2.default.createElement(ProjectLink, {
      object: Project
    }), ')') : null) : null), _react2.default.createElement(_Grid2.default, {
      item: true,
      className: classes.buttons
    }, this.getButtons()), showCreatedBy ? _react2.default.createElement(_Grid2.default, {
      item: true
    }, CreatedBy ? _react2.default.createElement(UserLink, {
      user: CreatedBy,
      showName: false,
      size: 'small'
    }) : null) : null))));
  };

  TaskView.prototype.renderChat = function renderChat() {
    var _props4 = this.props,
        showChat = _props4.showChat,
        updateChatRoomProcessor = _props4.updateChatRoomProcessor;

    if (!showChat) {
      return null;
    }

    var object = this.getObjectWithMutations(); // const {
    //   user: currentUser,
    // } = this.context;

    var _ref9 = object || {},
        id = _ref9.id;

    if (!id) {
      return null;
    }

    return _react2.default.createElement(_ChatRooms2.default, {
      task: object,
      where: {
        Task: {
          id: id
        }
      },
      first: 1,
      addObject: function addObject() {},
      updateChatRoomProcessor: updateChatRoomProcessor // currentUser={currentUser}

    });
  };

  TaskView.prototype.renderDefaultView = function renderDefaultView() {
    var _this2 = this;

    var _props5 = this.props,
        classes = _props5.classes,
        showDetails = _props5.showDetails,
        showStatus = _props5.showStatus,
        TaskStatusSelect = _props5.TaskStatusSelect;
    var _context4 = this.context,
        Editor = _context4.Editor,
        currentUser = _context4.user;
    var object = this.getObjectWithMutations();

    if (!object) {
      return null;
    }

    var content = object.content,
        Timers = object.Timers,
        startDatePlaning = object.startDatePlaning,
        endDatePlaning = object.endDatePlaning,
        startDate = object.startDate,
        endDate = object.endDate,
        status = object.status;
    var inEditMode = this.isInEditMode();
    var allow_edit = this.canEdit();
    var details = void 0;

    if (showDetails) {
      details = _react2.default.createElement(_react.Fragment, null, Timers && Timers.length ? _react2.default.createElement(_Grid2.default, {
        item: true,
        xs: 12
      }, _react2.default.createElement(_materialUi.Typography, {
        variant: 'subheading'
      }, "\u0422\u0430\u0439\u043C\u0435\u0440\u044B \u0432 \u0437\u0430\u0434\u0430\u0447\u0435"), _react2.default.createElement(_List2.default, {
        timers: Timers
      })) : null);
    }

    return _react2.default.createElement(_Grid2.default, {
      container: true // spacing={8}
      ,
      className: [classes.item, status || ""].join()
    }, (showStatus || inEditMode) && status ? _react2.default.createElement(TaskStatusSelect, {
      value: status,
      inEditMode: inEditMode,
      onChange: function onChange(event) {
        var _this2$updateObject;

        var _event$target = event.target,
            value = _event$target.value,
            name = _event$target.name;

        _this2.updateObject((_this2$updateObject = {}, _this2$updateObject[name] = value, _this2$updateObject));
      }
    }) : null, inEditMode || content ? _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: 12
    }, _react2.default.createElement(_materialUi.Typography, {
      variant: 'subheading'
    }, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u0437\u0430\u0434\u0430\u0447\u0438"), _react2.default.createElement(Editor, {
      value: content,
      readOnly: !inEditMode,
      onChange: function onChange(content) {
        return _this2.updateObject({
          content: content
        });
      }
    })) : null, inEditMode || startDatePlaning ? _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: 12
    }, this.getTextField({
      name: "startDatePlaning",
      label: "Планируемая дата начала",
      type: "date",
      value: startDatePlaning && (0, _moment2.default)(startDatePlaning).format("YYYY-MM-DD") || "дд.мм.гггг",
      disabled: !inEditMode
    })) : null, inEditMode || endDatePlaning ? _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: 12
    }, this.getTextField({
      name: "endDatePlaning",
      label: "Планируемая дата завершения",
      type: "date",
      value: endDatePlaning && (0, _moment2.default)(endDatePlaning).format("YYYY-MM-DD") || "дд.мм.гггг",
      disabled: !inEditMode
    })) : null, inEditMode || startDate ? _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: 12
    }, this.getTextField({
      name: "startDate",
      label: "Дата начала",
      type: "date",
      value: startDate && (0, _moment2.default)(startDate).format("YYYY-MM-DD") || "дд.мм.гггг",
      disabled: !inEditMode
    })) : null, inEditMode || endDate ? _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: 12
    }, this.getTextField({
      name: "endDate",
      label: "Дата завершения",
      type: "date",
      value: endDate && (0, _moment2.default)(endDate).format("YYYY-MM-DD") || "дд.мм.гггг",
      disabled: !inEditMode
    })) : null, details, _react2.default.createElement(_Grid2.default, {
      item: true,
      xs: 12
    }, this.renderChat()));
  };

  TaskView.prototype.renderEditableView = function renderEditableView() {
    return this.renderDefaultView();
  };

  TaskView.prototype.renderResetButton = function renderResetButton() {
    var _ref10 = this.getObjectWithMutations() || {},
        id = _ref10.id;

    return id ? _EditableView.prototype.renderResetButton.call(this) : null;
  };

  TaskView.prototype.render = function render() {
    var object = this.getObjectWithMutations();

    if (!object) {
      return null;
    }

    var classes = this.props.classes;
    return _react2.default.createElement('div', {
      className: classes.root
    }, _EditableView.prototype.render.call(this));
  };

  return TaskView;
}(_Editable2.default), _class.propTypes = _extends({}, _Editable2.default.propTypes, {
  classes: _propTypes2.default.object.isRequired,
  showDetails: _propTypes2.default.bool.isRequired,
  showStatus: _propTypes2.default.bool.isRequired,
  showCreatedBy: _propTypes2.default.bool.isRequired,
  TaskStatusSelect: _propTypes2.default.func.isRequired,
  mutate: _propTypes2.default.func,
  createTimer: _propTypes2.default.func.isRequired,
  updateTimer: _propTypes2.default.func.isRequired,
  showChat: _propTypes2.default.bool.isRequired
}), _class.defaultProps = _extends({}, _Editable2.default.defaultProps, {
  showDetails: false,
  showStatus: true,
  showCreatedBy: true,
  TaskStatusSelect: _Select2.default,
  showChat: false
}), _temp); // export default withStyles(styles)(TaskView);
// const processors = compose(
//   graphql(createTaskProcessor, {
//     name: "createTask",
//   }),
//   graphql(updateTaskProcessor, {
//     name: "updateTask",
//   }),
//   graphql(createTimerProcessor, {
//     name: "createTimer",
//   }),
//   graphql(updateTimerProcessor, {
//     name: "updateTimer",
//   }),
//   // graphql(taskQuery, {
//   //   name: "getTask",
//   // }),
// );
// export {
//   processors,
// }
// export default processors(withStyles(styles)(props => <TaskView 
//   {...props}
// />));

var TaskConnector = exports.TaskConnector = (_temp2 = _class2 = function (_Component) {
  _inherits(TaskConnector, _Component);

  function TaskConnector() {
    _classCallCheck(this, TaskConnector);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  TaskConnector.prototype.componentWillMount = function componentWillMount() {
    var _context$query = this.context.query,
        createTaskProcessor = _context$query.createTaskProcessor,
        updateTaskProcessor = _context$query.updateTaskProcessor,
        createTimerProcessor = _context$query.createTimerProcessor,
        updateTimerProcessor = _context$query.updateTimerProcessor,
        updateChatRoomProcessor = _context$query.updateChatRoomProcessor;
    var View = this.props.View;
    this.Renderer = (0, _reactApollo.compose)((0, _reactApollo.graphql)((0, _graphqlTag2.default)(createTaskProcessor), {
      name: "createTask"
    }), (0, _reactApollo.graphql)((0, _graphqlTag2.default)(updateTaskProcessor), {
      name: "updateTask"
    }), (0, _reactApollo.graphql)((0, _graphqlTag2.default)(createTimerProcessor), {
      name: "createTimer"
    }), (0, _reactApollo.graphql)((0, _graphqlTag2.default)(updateTimerProcessor), {
      name: "updateTimer"
    }), (0, _reactApollo.graphql)((0, _graphqlTag2.default)(updateChatRoomProcessor), {
      name: "updateChatRoomProcessor"
    }))(View);
    _Component.prototype.componentWillMount && _Component.prototype.componentWillMount.call(this);
  };

  TaskConnector.prototype.render = function render() {
    var Renderer = this.Renderer;

    var _props6 = this.props,
        View = _props6.View,
        other = _objectWithoutProperties(_props6, ['View']);

    return _react2.default.createElement(Renderer, other);
  };

  return TaskConnector;
}(_react.Component), _class2.contextType = _context6.default, _class2.defaultProps = {
  View: TaskView
}, _temp2);
TaskConnector.propTypes = process.env.NODE_ENV !== "production" ? {
  View: _propTypes2.default.func.isRequired
} : {};
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(TaskConnector, props);
});